import TagManagementPage from '@/components/pages/tag-management/TagManagementPage.vue';

export default [
  {
    path: 'tags/overview',
    name: 'tags.overview',
    meta: { access: { menu: 'course', subMenu: 'course-tag-mgmt' } },
    component: TagManagementPage,
  },
];
